<div>
  <span class="title title--big">
    {{ isGRS ? 'Смена ГРРС' : 'Смена' }}
  </span>
</div>
<div class="grid mb-24">
  <div class="grid__box grid__box--size-min grid__box--pull-left">
    <span class="font-size-15 color-gray-dark">{{ currentDate | dateFormat: 'DD MMMM YYYY г.' }}</span>
  </div>
  <div class="grid__box grid__box--size-min grid__box--pull-right">
    <div class="grid grid--va-middle grid--gap-24 font-size-15">
      <div class="grid__box grid__box--size-min">
        <span class="title">Участки</span>
      </div>
      <ng-container *ngIf="sectorsList && sectorsList.length">
        <div class="grid__box grid__box--size-min" *ngFor="let sector of sectorsList">
          <a
            class="link"
            (click)="onSelectSector(sector)"
            [ngClass]="{
              'font-weight-bold no-underline': sector.sector_id === sectorId,
              'link--dotted-blue-dark': sector.sector_id !== sectorId
            }"
            [routerLink]="makeLink(sector, false)"
          >
            {{ sector.sector_number_str }}
          </a>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<ng-container *ngIf="sectorsList && sectorsList.length">
  <router-outlet></router-outlet>
</ng-container>
